exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".deletedUserRow-4c56e{background-color:#d9d9d9}", ""]);

// Exports
exports.locals = {
	"deletedUserRow": "deletedUserRow-4c56e"
};